import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import {
  convertBedbankPropertyAddressToString,
} from 'tripPlanner/utils'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { startPlaceOfTripItem } from 'tripPlanner/components/TripMaps/utils'
import PlaceActionChips from 'tripPlanner/components/PlaceActionChips'

interface Prop {
  item: TripItem
  address: string | App.BedbankPropertyAddress
  addressLabel?: string
}

const Address = styled.div`
  display: flex;
  flex-direction: column;
`

function AddressWithViewMapButton({
  item,
  address,
  addressLabel,
}: Prop) {
  const intl = useIntl()
  const defaultAddressLabel = intl.formatMessage({
    id: 'wy-Vi9kX7dyEcMtq4AlZ',
    defaultMessage: 'Address',
    description: 'Default label for the address section of a trip item summary',
  })
  const resolvedAddressLabel = addressLabel ?? defaultAddressLabel
  const place = startPlaceOfTripItem(item)

  const getAddress = () => {
    if (typeof address === 'string') {
      return address
    }

    return convertBedbankPropertyAddressToString(address)
  }

  return (
    <>
      <Address>
        <BodyText variant="medium" weight="bold">
          {resolvedAddressLabel}
        </BodyText>
        {place?.name && <BodyText variant="large">{place.name}</BodyText>}
        <BodyText variant="large">{getAddress()}</BodyText>
      </Address>
      {place && (
        <PlaceActionChips
          place={place}

        />
      )}
    </>
  )
}

export default AddressWithViewMapButton
